import React, { useMemo } from "react";
import { ReactComponent as ApplePaySVG } from "../../../../../../../../images/svg/public/order/paymentMethods/apple-pay.svg";
import { ReactComponent as BlikSVG } from "../../../../../../../../images/svg/public/order/paymentMethods/blik.svg";
import { ReactComponent as GooglePaySVG } from "../../../../../../../../images/svg/public/order/paymentMethods/google-pay.svg";
import { OrderPaymentMethodType } from "../../../../../../../../services/Api/Public/types";

interface Props {
	paymentMethodType: OrderPaymentMethodType;
}

const OrderPaymentMethod = ({ paymentMethodType }: Props) => {
	const renderIcon = useMemo(() => {
		switch (paymentMethodType) {
			case OrderPaymentMethodType.APPLE_PAY:
				return <ApplePaySVG />;
			case OrderPaymentMethodType.GOOGLE_PAY:
				return <GooglePaySVG />;
			case OrderPaymentMethodType.BLIK:
				return <BlikSVG />;
			default:
				return null;
		}
	}, [paymentMethodType]);

	return <div className="payment-brand">{renderIcon}</div>;
};

export default OrderPaymentMethod;
